/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Byty_CzInputs */

const cs_enum_byty_cz = /** @type {(inputs: Enum_Byty_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byty.cz`)
};

const en_enum_byty_cz = /** @type {(inputs: Enum_Byty_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byty.cz`)
};

/**
* | output |
* | --- |
* | "Byty.cz" |
*
* @param {Enum_Byty_CzInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_byty_cz = /** @type {((inputs?: Enum_Byty_CzInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Byty_CzInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_byty_cz(inputs)
	return cs_enum_byty_cz(inputs)
});